import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";

const activarMutuo = async (mutuoId: number, ignorePrecioVenta: boolean, ignoreHeaders: boolean) => {
    const headers = !ignoreHeaders ? {
            'X-Hide-Toast': 'true',
            "X-Hide-Loader" : 'true',
        } : {}
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-mutuo/v1/mutuo/activar-mutuo`, {
        mutuoId,
        ignorePrecioVenta
    }, {
        headers: headers
    });
    return response;
}

export {
    activarMutuo
};